import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageSkeletonProps = ComponentProps<"div"> & {
  count?: number
}

function ManageSkeleton(props: ManageSkeletonProps) {
  const { count = 3, className, ...divProps } = props

  return (
    <div className={cn("px-1", className)} {...divProps}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="manage-skeleton-item">
          <div className="manage-skeleton-bar manage-skeleton-primary" />
          <div className="manage-skeleton-bar manage-skeleton-secondary" />
        </div>
      ))}
    </div>
  )
}

export default ManageSkeleton
